import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from "primereact/inputtext";
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { Captcha } from 'primereact/captcha';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import servicioObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioHttp from '../servicios/ServicioHttp';
import { autenticar } from '../servicios/ServicioAutenticacion';

export class NuevoUsuario extends Component {
    constructor(props) {
        super();
        this.state = {
            mostrarRegistro: false,
            usuario: {},
            errores: {},
            verificaCapchap: false,
            mostrarContrasenas: false
        };

    }

    mostrarModalRegistro = () => {
        this.setState({ usuario: {}, errores: {}, mostrarRegistro: true });
    }

    cerrarModal = () => {
        this.setState({ usuario: {}, errores: {}, mostrarRegistro: false });
    }

    asignarDatos = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    }

    crearCuenta = () => {
        let { usuario, tokenCaptcha } = this.state;
        const validacion = this.validarFormulario(usuario);
        this.setState({ errores: validacion });
        if (servicioObjetos.esObjetoVacio(validacion)) {
            let correoconfirmacion = usuario.correoconfirmacion;
            let confirmacontrasena = usuario.confirmacontrasena;
            delete usuario.correoconfirmacion;
            delete usuario['correoconfirmacion'];
            delete usuario.confirmacontrasena;
            delete usuario['confirmacontrasena'];
            usuario.token = tokenCaptcha;
            servicioHttp.consumirPostHttp('/usuario/nuevo_usuario.json', usuario).then(response => {
                this.growl.clear();
                this.growl.show({ severity: response.data.error ? 'error' : 'success', summary: '', detail: response.data.mensaje, life: 20000 });
                if (!response.data.error) {
                    this.cerrarModal();
                    autenticar(usuario.usuario, usuario.contrasena).then(response => {
                        window.location = '/Capufe/bienvenido/ticket';
                    }).catch(error => {
                        this.growl.show({ severity: "error", summary: "", detail: error });
                    });
                } else {
                    usuario.correoconfirmacion = correoconfirmacion;
                    usuario.confirmacontrasena = confirmacontrasena;
                    this.expireCaptcha();
                }
            }).catch(error => {
                this.growl.show({ severity: 'error', summary: '', detail: "Existe un error de conexión al servidor, intente más tarde", life: 20000 });
            });
        }
    }

    validarFormulario = (usuario) => {
        const errores = {};
        var expreReg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        var validacionCorreo = expreReg.exec(usuario.usuario);

        if (!usuario.nombre)
            errores.nombre = "El nombre es requerido";       
        if (!usuario.usuario)
            errores.usuario = "El usuario es requerido";
        if (!validacionCorreo)
            errores.correo = "El correo no es valido";
        if (!usuario.contrasena)
            errores.contrasena = "La contraseña es requerida";
        if (!usuario.confirmacontrasena)
            errores.confirmacontrasena = "La confirmación de contraseña es requerida";
        if (usuario.contrasena !== usuario.confirmacontrasena)
            errores.confirmacontrasena = "Las contraseñas no coinciden";
        if (!usuario.correoconfirmacion)
            errores.correoconfirmacion = "Los correos no coinciden";
        if (usuario.correoconfirmacion !== usuario.usuario)
            errores.correoconfirmacion = "El correo no coincide";
        let { tokenCaptcha } = this.state;
        if (servicioObjetos.esObjetoVacio(tokenCaptcha))
            errores.captcha = 'Debe de resolver el captcha';
        if (!usuario.telefono)
            errores.telefono = "El telefono el requerido";    
        return errores;
    }

    respuestaCaptcha = (response) => {
        this.setState({
            tokenCaptcha: response.response
        });
    }

    expireCaptcha = () => {
        let { errores } = this.state;
        delete errores.captcha;
        delete errores['captcha'];
        this.setState({ errores: errores });
        this.setState({ tokenCaptcha: null });
        this.captcha.reset();
    }

    mostrarContrasenas = (mostrarContrasenas) => {
        if (mostrarContrasenas) {
            this.password.inputEl.type = "text";
            this.passwordConfirmacion.inputEl.type = "text";
        } else {
            this.password.inputEl.type = "password";
            this.passwordConfirmacion.inputEl.type = "password";
        }
        this.setState({ mostrarContrasenas: mostrarContrasenas });
    }

    render() {
        let { usuario, errores, mostrarRegistro, mostrarContrasenas } = this.state;

        const pieDialogo = (
            <div className="ui-dialog-buttonpane p-clearfix">
                <Button label="Guardar" icon="pi-md-check" onClick={this.crearCuenta} />
                <Button label="Cancelar" icon="pi-md-close" onClick={this.cerrarModal} className="p-button-danger" />
            </div>
        );

        return (
            <div>
                <Growl ref={(el) => this.growl = el} />
                <span className="cursor" onClick={this.mostrarModalRegistro}><strong style={{ color: '#4f9cd2' }}>Registrate Aquí</strong></span>                
                <Dialog appendTo={document.body} header="Regístrate" visible={mostrarRegistro} modal={true} onHide={this.cerrarModal} footer={pieDialogo}>
                    <div className="p-col-12">
                        <div className="card card-w-title">
                            <div className="p-grid form-group">
                                <div className="p-col-12 p-md-12"></div>                               
                                <div className="p-col-12 p-md-12">
                                    <span className="md-inputfield">
                                        <InputText className={errores.nombre ? "p-error" : ""} id="usuario.nombre" name="usuario.nombre" style={{ width: '100%' }} onChange={(e) => { this.asignarDatos(e, true) }} value={usuario.nombre || ""} />
                                        <label>* Nombre Completo</label>
                                        {errores.nombre ? <div> <Message severity="error" text={errores.nombre} /> </div> : null}
                                    </span>
                                </div>
                                <div className="p-col-12 p-md-12">
                                    <span className="md-inputfield">
                                        <Password ref={el => this.password = el} id="usuario.contrasena" name="usuario.contrasena" value={usuario.contrasena || ""} className={errores.contrasena ? "p-error" : ""} onChange={(e) => { this.asignarDatos(e, false) }} style={{ width: '100%' }}
                                            promptLabel="Por favor ingresa una contraseña" weakLabel="Contraseña débil" mediumLabel="Contraseña insegura" strongLabel="Contraseña segura" />
                                        <label>* Contraseña</label>
                                        {errores.contrasena ? <div> <Message severity="error" text={errores.contrasena} /> </div> : null}
                                    </span>
                                </div>
                                <div className="p-col-12 p-md-12">
                                    <span className="md-inputfield">
                                        <Password ref={el => this.passwordConfirmacion = el} id="usuario.confirmacontrasena" name="usuario.confirmacontrasena" value={usuario.confirmacontrasena || ""} className={errores.confirmacontrasena ? "p-error" : ""} onChange={(e) => { this.asignarDatos(e, false) }} style={{ width: '100%' }}
                                            promptLabel="Por favor confirma la contraseña" weakLabel="Contraseña débil" mediumLabel="Contraseña insegura" strongLabel="Contraseña segura" />
                                        <label>* Confirma Contraseña</label>
                                        {errores.confirmacontrasena ? <div> <Message severity="error" text={errores.confirmacontrasena} /> </div> : null}
                                    </span>
                                </div>
                                <div className="p-col-12 p-md-12">
                                    <Checkbox inputId="cb1" checked={mostrarContrasenas} onChange={e => this.mostrarContrasenas(e.checked)} />
                                    <label htmlFor="cb1" className="p-checkbox-label"><i className="pi-md-remove-red-eye"></i>Mostrar Contraseñas</label>
                                </div>
                                <div className="p-col-12 p-md-12">
                                    <span className="md-inputfield">
                                        <InputText className={errores.correo ? "p-error" : ""} id="usuario.usuario" name="usuario.usuario" style={{ width: '100%' }} onChange={(e) => { this.asignarDatos(e, false) }} value={usuario.usuario || ""} />
                                        <label>* Correo</label>
                                    </span>
                                    {errores.usuario ? <div> <Message severity="error" text={errores.usuario} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-12">
                                    <span className="md-inputfield">
                                        <InputText className={errores.correoconfirmacion ? "p-error" : ""} id="usuario.correoconfirmacion" name="usuario.correoconfirmacion" style={{ width: '100%' }} onChange={(e) => { this.asignarDatos(e, false) }} value={usuario.correoconfirmacion || ""} />
                                        <label>* Confirmar Correo</label>
                                    </span>
                                    {errores.correoconfirmacion ? <div> <Message severity="error" text={errores.correoconfirmacion} /> </div> : null}
                                </div>

                                <div className="p-col-12 p-md-12">                                    
                                    <span className="md-inputfield">
                                        <InputText className={errores.telefono ? "p-error" : ""} id="usuario.telefono" name="usuario.telefono" style={{ width: '100%' }} onChange={(e) => { this.asignarDatos(e, false) }} value={usuario.telefono || ""} />
                                        <label>* Teléfono</label>
                                    </span>
                                    {errores.telefono ? <div><br /> <Message severity="error" text={errores.telefono} /> </div> : null}
                                </div>

                                <div className={errores.captcha ? 'p-col-12 p-md-10 p-error' : 'p-col-12 p-md-10'}>
                                    <Captcha ref={(r) => this.captcha = r} siteKey="6Lc5NNIZAAAAAE516_ffb7LZRGAsD6WysJ0YJhOQ" onResponse={this.respuestaCaptcha} onExpire={this.expireCaptcha} language="es"></Captcha>
                                    {errores.captcha ? <div><Message severity="error" text={errores.captcha} /> </div> : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}